import { mode } from '@chakra-ui/theme-tools';
import { extendTheme } from "@chakra-ui/react"
// import globalStyleTheme from "./styles";

const styles = {
    global: (props) => ({
        "body": {
            fontFamily: "body",
            color: mode("gray.800", "whiteAlpha.900")(props),
            bg: mode("white", "gray.800")(props),
            lineHeight: "base"
        },
        "*::placeholder": {
            color: mode("gray.400", "whiteAlpha.400")(props),
        },
        "*, *::before, &::after": {
            borderColor: mode("gray.200", "whiteAlpha.300")(props),
            wordWrap: "break-word",
        }
    })
};

const config = {
    initialColorMode: "light",
    useSystemColorMode: false,
    styles,
    colors: {
        brand: {
            primary: "#24c85e",
        }
    } 
}

// 3. extend the theme
const theme = extendTheme(config);

export default theme;